<template>
  <div class="mt-6 text-center">
    <div
      class="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs text-slate-500 dark:text-slate-400 bg-slate-100/70 dark:bg-slate-900/60 border border-slate-200/70 dark:border-slate-800/80"
    >
      <ShieldCheck class="w-3.5 h-3.5 text-emerald-500" />
      <span class="font-medium">Enterprise 256-bit SSL encryption</span>
    </div>
  </div>
</template>

<script setup>
import { ShieldCheck } from "lucide-vue-next";
</script>
